import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    eventdate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide a guest count in numbers only.'},
      ]
    },
    sitename: {
      validations: []
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please select an option' },
      ]
    },
    reference: {
      validations: [
        { type: 'required', message: 'Please select an option' },
      ]
    },
    eventextra7: {
      validations: []
    },
    Website: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventdate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Planned Guest Count:*',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Venue/Location:',
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event:*',
            options: [
              { label: 'Wedding', value: 'Wedding'},
              { label: 'Corporate', value: 'Corporate'},
              { label: 'Graduation', value: 'Graduation'},
              { label: 'Social', value: 'Social'},
              { label: 'Celebration of Life', value: 'Celebration of Life'},
              { label: 'Other', value: 'Other'},
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'How Did You Hear About Us?:*',
        options: [
          { label: 'Bridal Show', value: 'Bridal Show'},
          { label: 'Email Blast', value: 'Email Blast'},
          { label: 'Google', value: 'Google'},
          { label: 'MN Bride', value: 'MN Bride'},
          { label: 'Networking Event', value: 'Networking Event'},
          { label: 'Printed Material', value: 'Printed Material'},
          { label: 'Previous or Current client', value: 'Previous or Current client'},
          { label: 'Social', value: 'Social'},
          { label: 'Venue Referral', value: 'Venue Referral'},
          { label: 'Word of Mouth', value: 'Word of Mouth'},          
        ],
        mapping: 'reference'
      }
    ]
  },
  {
    fields: [
      {
        type: 'checkbox-list',
        size: 'Medium',
        label: 'Are you interested in hearing about our other brands?:',
        options:[
        {label: 'Yes' , value: 'Yes'},
        {label: 'No' , value: 'No'},
        ],
        mapping: 'eventextra7'
      }
    ]
  },
  {
    fields: [
      {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'A\'BriTin Catering & Hospitality Contact Form',
    formId: '2178',
    clientKey: 'E29F1AF0-98BC-423E-AE42-46E8947A1F2B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText: 'Thank you! Your submission was sent. We will reach out to you within 24 business hours.',
    redirectUrl: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
